import {
  Autocomplete,
  CardActions,
  CardContent,
  CardHeader,
  Dialog,
  FormControl,
  FormHelperText,
  Grid,
  Paper,
  TextField,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import AppButton from "../../../shares/AppButton";
import { CVService } from "../../../../../service/CVService";
import { TYPE_NOTIFICATION } from "../../../shares/NotificationBull";
import useToast from "../../../../../hooks/useToast";
import { useQuery } from "../../../../../hooks/useQuery";
import AppFileImput from "../../../shares/AppFileImput";
import { uploadService } from "../../../../../service/UploadService";
import { enleverBaliseHtml } from "../../../../../Helpers/utilsHelper";
import { CVEducationService } from "../../../../../service/CVEducationService";
import StandardSkeletoon from "../../../shares/loader/StandardSkeletoon";
import { useToastStore } from "../../../../../stores/toastStore";
const INIT_EDUCATION = {
  annee: null,
  diplome: null,
  etablissement: null,
  filiere: null,
  description: null,
  file_diplome: null,
};
const INIT_EDUCATION_ERROR = {
  annee_error: null,
  diplome_error: null,
  etablissement_error: null,
  filiere_error: null,
  description_error: null,
  file_diplome_error: null,
};
const EducationForm = ({ open, onFormClose, onFormOpen, id_education }) => {
  const [currentEducation, setCurrentEducation] = useState(INIT_EDUCATION);
  const [formErrors, setFormErrors] = useState(INIT_EDUCATION_ERROR);
  const [isSubmited, setIsSubmited] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [formLoading, setFormLoading] = useState(false);
  const [filieres, setFilieres] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
  const optionsDiplomes = [
    "CEPE",
    "BEPC",
    "Bacc",
    "Bacc+2-DTS",
    "Bacc+3-Licence",
    "Bacc + 4-Maitrise",
    "Bacc + 5-Master II/Ingenieur",
    "DEA",
    "AEA",
    "Doctorat",
  ];
  const showToastStore = useToastStore((state) => state.showToast);
  const query = useQuery();
  const id_identite = query.get("ref");

  const handleFormClose = () => {
    onFormClose();
    setFormErrors(INIT_EDUCATION_ERROR);
    setCurrentEducation(INIT_EDUCATION);
    setIsSubmited(false);
  };

  const handleChangeCurrentEducation = (e) => {
    const { name, value } = e.target;
    setCurrentEducation({ ...currentEducation, [name]: value });
  };

  const handleCheckError = () => {
    const currentYear = new Date().getFullYear();

    setFormErrors({
      annee_error: !currentEducation.annee
        ? "Année est requis"
        : currentYear < currentEducation.annee
          ? "L'année ne peut pas dépasser l'année courrante"
          : null,
      diplome_error: !currentEducation.diplome ? "Diplome est requis" : null,
      etablissement_error: !currentEducation.etablissement
        ? "Etablissement est requis"
        : null,
      filiere_error: !currentEducation.filiere ? "Filiere est requis" : null,
      description_error: !currentEducation.description
        ? "Parcours / Description obligatoire"
        : null,
      file_diplome_error: !currentEducation.file_diplome
        ? "Veuillez attacher votre diplome"
        : null,
    });
    return Object.values(formErrors).every((error) => error === null);
  };

  const handleFetchEducation = () => {
    setFormLoading(true);
    CVEducationService.find_by_id(id_education)
      .then((res) => {
        if (res.success) {
          setCurrentEducation(res.data);
        } else {
          showToastStore(TYPE_NOTIFICATION.ERROR, res.message);
        }
      })
      .finally(() => {
        setFormLoading(false);
      });
  };

  const handleFetchFiliereList = (filtre) => {
    CVService.getFiliereList(filtre).then((res) => {
      if (res && res.data) {
        setFilieres(res.data);
      }
    });
  };

  const getInsertableData = () => {
    return {
      ...currentEducation,
      id_ext_user: id_identite,
    };
  };

  const handleInsertEducation = () => {
    setSubmitting(true);
    CVEducationService.insert(getInsertableData())
      .then((res) => {
        if (res && res.success) {
          //setCurrentEducation(res.data);
          setFormErrors(INIT_EDUCATION_ERROR);
          setIsSubmited(false);
          onFormClose();
          showToastStore(TYPE_NOTIFICATION.SUCCESS, res.message);
        } else {
          showToastStore(TYPE_NOTIFICATION.ERROR, res.message);
        }
      })
      .finally(() => {
        setSubmitting(false);
      });
  };
  const handleUpdateEducation = () => {
    setSubmitting(true);
    CVEducationService.update(currentEducation)
      .then((res) => {
        if (res.success) {
          setCurrentEducation(res.data);
          showToastStore(TYPE_NOTIFICATION.SUCCESS, res.message);
          handleFormClose();
        } else {
          showToastStore(TYPE_NOTIFICATION.ERROR, res.message);
        }
      })
      .finally(() => {
        setSubmitting(false);
      });
  };

  const handleSubmit = () => {
    setIsSubmited(true);
    if (handleCheckError()) {
      if (id_education) {
        handleUpdateEducation();
      } else {
        handleInsertEducation();
      }
    } else {
      showToastStore(
        TYPE_NOTIFICATION.ERROR,
        "Veuillez verifier les champs de saisis",
      );
    }
  };

  const handleFileUpload = (file) => {
    setFormErrors({
      ...formErrors,
      file_diplome_error: "Telechargement du fichier en cours...",
    });
    uploadService.uploadFile(file).then((res) => {
      if (!(res && res.success)) {
        showToastStore(TYPE_NOTIFICATION.ERROR, enleverBaliseHtml(res.error));
        setCurrentEducation({
          ...currentEducation,
          file_diplome: res && res.success ? res.data.file_name : null,
        });
      } else {
        setCurrentEducation({
          ...currentEducation,
          file_diplome: res.data.file_name,
        });
        setFormErrors({
          ...formErrors,
          file_diplome_error: enleverBaliseHtml(res.error),
        });
      }
    });
  };

  useEffect(() => {
    if (open && id_education) {
      handleFetchEducation();
    }
    handleFetchFiliereList();
  }, [open, id_education]);

  useEffect(() => {
    handleCheckError();
  }, [currentEducation]);

  useEffect(() => {
    if (selectedFile) {
      handleFileUpload(selectedFile);
    }
  }, [selectedFile]);

  return (
    <>
      <Dialog open={open} onClose={handleFormClose} fullWidth maxWidth="xs">
        <Paper sx={{ m: 3 }} elevation={0}>
          <StandardSkeletoon show={formLoading} row={3} escalier />
          <Grid display={formLoading ? "none" : ""}>
            <CardHeader title="Education" />
            <CardContent>
              <Grid container>
                <FormControl fullWidth>
                  <label>Année *</label>
                  <TextField
                    id="annee"
                    name="annee"
                    onChange={handleChangeCurrentEducation}
                    size="small"
                    type="number"
                    placeholder="Année d'obtention du diplôme"
                    fullWidth
                    sx={{
                      "& input": {
                        textAlign: "right",
                      },
                    }}
                    value={currentEducation.annee}
                    error={formErrors.annee_error && isSubmited}
                    helperText={isSubmited ? formErrors.annee_error : ""}
                    aria-describedby="annee_helper"
                  />
                  <FormHelperText id="annee_helper"></FormHelperText>
                </FormControl>
                <FormControl fullWidth>
                  <label>Diplome *</label>
                  <Autocomplete
                    // freeSolo
                    name="diplome"
                    id="diplome"
                    options={optionsDiplomes}
                    value={currentEducation.diplome || ""}
                    onChange={(event, newValue) => {
                      handleChangeCurrentEducation({
                        target: { name: "diplome", value: newValue || "" },
                      });
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        id="diplome"
                        name="diplome"
                        size="small"
                        placeholder="Diplôme obtenu"
                        fullWidth
                        error={formErrors.diplome_error && isSubmited}
                        helperText={isSubmited ? formErrors.diplome_error : ""}
                        aria-describedby="diplome_helper"
                      />
                    )}
                  />
                  <FormHelperText id="diplome_helper"></FormHelperText>
                </FormControl>
                <FormControl fullWidth>
                  <label>Filiere / Serie / Option *</label>
                  <Autocomplete
                    freeSolo
                    name="filiere"
                    id="filiere"
                    options={filieres.map((item) => item.nom) || []}
                    value={currentEducation.filiere || ""}
                    onChange={(event, newValue) => {
                      handleChangeCurrentEducation({
                        target: { name: "filiere", value: newValue || "" },
                      });
                    }}
                    onInputChange={(event, newInputValue) => {
                      handleChangeCurrentEducation({
                        target: {
                          name: "filiere",
                          value: newInputValue || "",
                        },
                      });
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        id="filiere"
                        name="filiere"
                        size="small"
                        placeholder="Filiere"
                        fullWidth
                        error={formErrors.filiere_error && isSubmited}
                        helperText={isSubmited ? formErrors.filiere_error : ""}
                        aria-describedby="filiere_helper"
                      />
                    )}
                  />
                  <FormHelperText id="filiere_helper"></FormHelperText>
                </FormControl>
                <FormControl fullWidth>
                  <label>Etablissement *</label>
                  <TextField
                    id="etablissement"
                    name="etablissement"
                    onChange={handleChangeCurrentEducation}
                    size="small"
                    placeholder="Etablissement"
                    fullWidth
                    value={currentEducation.etablissement}
                    error={formErrors.etablissement_error && isSubmited}
                    helperText={
                      isSubmited ? formErrors.etablissement_error : ""
                    }
                    aria-describedby="etablissement_helper"
                  />
                  <FormHelperText id="etablissement_helper"></FormHelperText>
                </FormControl>
                <FormControl fullWidth>
                  <label>Parcours / description *</label>
                  <TextField
                    id="description"
                    name="description"
                    onChange={handleChangeCurrentEducation}
                    size="small"
                    type="text"
                    placeholder="Parcours"
                    fullWidth
                    value={currentEducation.description}
                    error={formErrors.description_error && isSubmited}
                    helperText={isSubmited ? formErrors.description_error : ""}
                    aria-describedby="nom_helper"
                  />
                  <FormHelperText id="nom_helper"></FormHelperText>
                </FormControl>
                <FormControl fullWidth>
                  <label>Attestation/Certificat</label>
                  <AppFileImput
                    name="file_diplome"
                    placeholder={"Attestation"}
                    handleFileUpload={(evt) => {
                      handleChangeCurrentEducation({
                        target: {
                          name: "file_diplome",
                          value: evt.target.files[0]?.name || "",
                        },
                      });
                      setSelectedFile(evt.target.files[0]);
                    }}
                    handleClearFile={(evt) => {
                      handleChangeCurrentEducation({
                        target: {
                          name: "file_diplome",
                          value: null,
                        },
                      });
                      setSelectedFile(null);
                    }}
                    file_name={currentEducation.file_diplome || ""}
                    allowedFIle={".jpeg,.jpg,.png,.pdf,.docx"}
                    error={formErrors.file_diplome_error && isSubmited}
                    helperText={formErrors.file_diplome_error}
                  />
                  <FormHelperText id="file_helper"></FormHelperText>
                </FormControl>
              </Grid>
            </CardContent>
            <CardActions sx={{ justifyContent: "flex-end" }}>
              <AppButton
                loading={submitting}
                text={"Enregistrer"}
                variant={"contained"}
                size={"medium"}
                onClick={handleSubmit}
              />
              <AppButton
                text={"Fermer"}
                variant={"outlined"}
                size={"medium"}
                onClick={handleFormClose}
              />
            </CardActions>
          </Grid>
        </Paper>
      </Dialog>
    </>
  );
};

export default EducationForm;
